import Menu from './VvsMenu'

export default Menu

export { default as MinerMoleMenu } from './MinerMoleMenu'
export { default as GotchiMenu } from './GotchiMenu'
